import React, { useEffect, useRef, useState, use } from 'react';
import NoteInlineEditor from './noteInlineEditor';
import { INoteData } from '../dto/INoteData';
import { useSelector } from 'react-redux';
import { IStateTree } from '../redux/store';

type PropType = {
    note: INoteData;
    onCancel: ()=>void;
    onDelete: ()=>void;
    forceOpenEditor: ()=>void;
    rightPanelOpenState?: boolean;
    categories: [];
}
type StateType = {
    isOverlapping: boolean;
}

function buildNotesBasedOnPosition(notes): INoteData[]{
  let arrOfNotes_ReturnObj: INoteData[] = [];
  let arrOfNotes = [] as Array<{position: number | undefined, note: INoteData}>;
  notes?.map((i, note)=>{
      if($("#" + note.id).offset()?.top === 0){
          console.warn("note should have a location");
      }
      arrOfNotes.push({
          position: $("#" + note.id).offset()?.top,
          note
      });
  });


  // Do sorting based on position value from low to high here
  arrOfNotes.sort((a, b) => {
      if (a.position === undefined || b.position === undefined) {
          return 0;
      }
      return a.position - b.position;
  });

  arrOfNotes.forEach((item) => {
      arrOfNotes_ReturnObj.push(item.note);
  });

  return arrOfNotes_ReturnObj;
}

// Varje mountad anteckning körde tidigare om denna DOM-frågning + sortering av ALLA
// anteckningar för varje enskild aNoteWasUpdated-händelse (O(n^2) för n anteckningar).
// Resultatet är identiskt för alla instanser inom samma händelse, så vi cachar det
// per updateKey och räknar bara ut det en gång.
let overlapPositionCache: { key: number; notes: INoteData[] } | null = null;

function getSortedOverlapNotesForUpdate(updateKey: number): INoteData[] {
  if (overlapPositionCache && overlapPositionCache.key === updateKey) {
    return overlapPositionCache.notes;
  }
  const notes = buildNotesBasedOnPosition($(".overlappingNote"));
  overlapPositionCache = { key: updateKey, notes };
  return notes;
}

export const OverlappingNoteComponent = (props: PropType, state: StateType) => {
    const noteRef = useRef(null);
    const [isBundled, setIsBundled] = useState(false); 
    const [belongsToBundle, setBelongsToBundle] = useState(""); 
    const [bundleLocationFromTop, setBundleLocationFromTop] = useState(0); 
    const [bundleIndex, setBundleIndex] = useState(""); 
    const [isOverlapping, setIsOverlapping] = useState(false); 
    const overlapMargin = 300;

    const aNoteWasUpdated = useSelector((state: IStateTree)=> state.document.aNoteWasUpdated);


    useEffect(() => {
      const sortedNotes = getSortedOverlapNotesForUpdate(aNoteWasUpdated);

      sortedNotes?.map((note, i)=>{

        if("OverlappingID"+props.note?.id === note.id){
          let thisLocation = $("#" + props.note.id).offset()?.top;
          let nextLocation = $("#" + sortedNotes[i + 1]?.id).offset()?.top;
          if(thisLocation && nextLocation){
            if((nextLocation - thisLocation) <= overlapMargin){
                  setIsOverlapping(true);
              } else {
                  setIsOverlapping(false);
              }
          }
        }
        if($("#" + props.note?.id).hasClass("collidingNote")){
          setIsBundled(true);
          setTimeout(()=>{
              const belongsto = $("#" + props.note?.id).attr("data-colliding");
              const bundleLocationFromTop = $("#b-" + props.note?.id).offset()?.top;
              const selfLocationFromTop = $("#OverlappingID" + props.note?.id).offset()?.top;
              bundleLocationFromTop && selfLocationFromTop && setBundleLocationFromTop(selfLocationFromTop-bundleLocationFromTop);
              const indexInBundle = $("#" + props.note?.id).attr("data-collidingIndex");
            belongsto && setBelongsToBundle(belongsto);
            indexInBundle && setBundleIndex(indexInBundle);
          },60)
        }
      });

    }, [aNoteWasUpdated]);

    // Rest of your component code here
  
    return (
      // JSX for your "NoteComponent" here
      // Make sure to add the ref to the root element of "NoteComponent"
      // style={{top: bundleLocationFromTop}}
      // -((bundleLocationFromTop * 2)+40)
      <div ref={noteRef} className={`overlappingNote ${isBundled ? "isBundled bundleIndex__"+bundleIndex : '' }`} id={"OverlappingID" + props.note.id}>
        {/* Your component content */}
        {/* For example, render your "NoteInlineEditor" component here */}
        <NoteInlineEditor {...props} isBundled={isBundled} belongsToBundle={belongsToBundle} overlapsSibling={isOverlapping}/>
      </div>
    );
  };
  